import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';

import { FormItem } from 'components/shared';
import { TextTypesOptions } from 'helpers/app.config';

export type TChildrenSelectOptions =
  | 'ticket'
  | 'shipment'
  | 'configComponents'
  | 'costReport'
  | 'shipmentReport'
  | 'problems'
  | 'changes'
  | 'releases';

type Props = {
  value: number;
  type?: TChildrenSelectOptions;
  onChangeTextType?: (data?: React.ChangeEvent<HTMLInputElement>) => void;
};

function SelectTextTypes({ value, onChangeTextType, type = 'ticket' }: Props) {
  const { t } = useTranslation('global');
  return (
    <FormItem>
      <Select
        name="textType"
        onChange={onChangeTextType}
        size="small"
        sx={{ width: '11em', textAlign: 'left' }}
        value={value}
      >
        {TextTypesOptions[type]?.map(({ label, id }) => (
          <MenuItem key={id} value={id}>
            {t(label)}
          </MenuItem>
        ))}
      </Select>
    </FormItem>
  );
}

export default SelectTextTypes;
